import { PRICE_BREAKS, SAVE_DESIGN_RELOAD_PRICEBREAKS } from "../actions";

const initialState = {
  loading: false,
  pricebreaks: null,
  upcharges: null,
  minimumQuantity: null,
  quantityIncrement: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case PRICE_BREAKS.REQUEST:
      return {
        ...state,
        loading: true,
      };

    case PRICE_BREAKS.SUCCESS:
      return {
        ...state,
        loading: false,
        pricebreaks: action.response.price_breaks,
        upcharges: action.response.upcharges_list,
        minimumQuantity: action.response.minimum_quantity,
        quantityIncrement: action.response.quantity_increment,
      };

    case PRICE_BREAKS.FAILURE:
      return {
        ...state,
        loading: false,
      };

    case SAVE_DESIGN_RELOAD_PRICEBREAKS:
      return {
        loading: true,
        pricebreaks: null,
        upcharges: null,
        minimumQuantity: null,
        quantityIncrement: null,
      };

    default:
      return state;
  }
}
